import { AllocationRuleDTO } from "../DTO/allocationRuleDTO";
import { AllocationField } from "./allocationField";
import { FieldDefinition } from "./fieldDefinition";

export class AllocationRule{

    public id!: number;
    public description!: string;
    public sourceFieldReference!: AllocationField;
    public sourceField!: FieldDefinition;
    public sourceFieldValue!: string;
    public destinationFieldReference!: AllocationField;
    public destinationField!: FieldDefinition;
    public destinationFieldValue!: string;
    public allocationPercentage!: number;
    public allocationMethod!: number;
    public weightFieldReferences!: AllocationField[];
    public weightFields!: FieldDefinition[];

    constructor(){
        this.weightFields = new Array();
    }

    public createFieldDefinitions(fieldDefinitions:FieldDefinition[]){
        if(this.sourceFieldReference) {
            this.sourceField = fieldDefinitions.find(f=>f.index==this.sourceFieldReference.index)!;
        }
        if(this.destinationFieldReference) {
            this.destinationField = fieldDefinitions.find(f=>f.index==this.destinationFieldReference.index)!;
        }
        if(this.weightFieldReferences) {
            this.weightFieldReferences.forEach(wfr=>{
                let fd = fieldDefinitions.find(f=>f.index==wfr.index);
                if(fd) {
                    this.weightFields.push(fd);
                }
            });
        }
    }

    public static mapFromDTO(param:AllocationRuleDTO):AllocationRule{ 
        if (!param) throw new Error("parameter is null")
        let obj = new AllocationRule();
        try
        {
            obj.id = param.id;
            obj.description = param.description;
            if(param.sourceFieldReference){
                obj.sourceFieldReference = JSON.parse(param.sourceFieldReference);
            }
            obj.sourceFieldValue = param.sourceFieldValue;
            if(param.destinationFieldReference){
                obj.destinationFieldReference = JSON.parse(param.destinationFieldReference);
            } 
            obj.destinationFieldValue = param.destinationFieldValue;
            if(param.weightFieldReferences){
                obj.weightFieldReferences = JSON.parse(param.weightFieldReferences);
            } 
            obj.allocationPercentage = param.allocationPercentage;
            obj.allocationMethod = param.allocationMethod;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:AllocationRule):AllocationRuleDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new AllocationRuleDTO();
        try
        {
            dto.id = param.id;
            dto.description = param.description;
            if(param.sourceField) dto.sourceFieldReference = JSON.stringify(param.sourceField.allocationField);
            dto.sourceFieldValue = param.sourceFieldValue;
            if(param.destinationField) dto.destinationFieldReference = JSON.stringify(param.destinationField.allocationField);
            dto.destinationFieldValue = param.destinationFieldValue;
            if(param.weightFields) {
                let wfArray:AllocationField[] = [];
                param.weightFields.forEach(wf=>{
                    wfArray.push(wf.allocationField);
                });
                dto.weightFieldReferences = JSON.stringify(wfArray);
            }
            dto.allocationPercentage = param.allocationPercentage;
            dto.allocationMethod = param.allocationMethod;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}